import { Component } from '@angular/core';
import { FeathersAppService } from '@fire/feathers/src/app';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'fc-admin-layout',
  templateUrl: './admin-layout.html',
  styleUrls: ['./admin-layout.scss'],
})
export class AdminLayoutComponent {


  constructor(
    private authService:AuthService,
  ) {

  }


  logout() {
    this.authService.logout();
  }





  //************************************************************


  fixedInViewport = false;
  get mode() { return 'side'; }  //  side, over, push
  get fixedTopGap() { return 0; }
  get fixedBottomGap() { return 0; }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/admin-layout/admin-layout.ts